import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { adminApi, errMsg } from "../api";
import { COLLECTIONS } from "../config";
import { toast } from "../../components/ui/sonner";

export default function CollectionList() {
  const { collection } = useParams();
  const cfg = COLLECTIONS[collection];
  const [items, setItems] = useState([]);

  const load = () => cfg && adminApi.get(cfg.api).then((r) => setItems(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [collection]);

  if (!cfg) {
    return <div className="adm-card" data-testid="unknown-collection">Unknown collection "{collection}".</div>;
  }

  const remove = async (item) => {
    if (!window.confirm(`Delete "${item.title || item.question}"? This cannot be undone.`)) return;
    try {
      await adminApi.delete(`${cfg.api}/${item.id}`);
      toast.success("Deleted");
      load();
    } catch (e) { toast.error(errMsg(e)); }
  };

  if (!cfg) return <div className="adm-empty">Unknown collection</div>;

  return (
    <div data-testid={`admin-${collection}-page`}>
      <div className="adm-head">
        <div>
          <h1>{cfg.title}</h1>
          <div className="sub">{items.length} item{items.length === 1 ? "" : "s"} — changes go live immediately</div>
        </div>
        <Link to={`/admin/${collection}/new`} className="adm-btn primary" data-testid={`add-${collection}`}>+ New {cfg.singular}</Link>
      </div>
      <div className="adm-card" style={{ padding: 0, overflow: "auto" }}>
        <table className="adm-table">
          <thead>
            <tr>{cfg.listCols.map((c) => <th key={c.key}>{c.label}</th>)}<th style={{ width: 160 }}>Actions</th></tr>
          </thead>
          <tbody>
            {items.map((it) => (
              <tr key={it.id} data-testid={`row-${it.slug || it.id}`}>
                {cfg.listCols.map((c) => (
                  <td key={c.key}>
                    {c.type === "bool"
                      ? <span className={`adm-badge ${it[c.key] ? "on" : "off"}`}>{it[c.key] ? "Yes" : "No"}</span>
                      : String(it[c.key] ?? "")}
                  </td>
                ))}
                <td>
                  <div style={{ display: "flex", gap: 8 }}>
                    <Link className="adm-btn ghost sm" to={`/admin/${collection}/${it.id}`} data-testid={`edit-${it.slug || it.id}`}>Edit</Link>
                    <button className="adm-btn danger sm" onClick={() => remove(it)} data-testid={`delete-${it.slug || it.id}`}>Delete</button>
                  </div>
                </td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={cfg.listCols.length + 1} className="adm-empty">Nothing here yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
